const GLOBAL_EDITION_CODE = 'global';

// TODO: @gokul-kathirvel This is just to merge the changes in master with the new picker.
// Once the new picker is enabled, this will be cleaned up.
const IS_GLOBAL_PREFERENCE_ENABLED = true;
export { GLOBAL_EDITION_CODE, IS_GLOBAL_PREFERENCE_ENABLED };
//# sourceMappingURL=constants.js.map
